export default __webpack_public_path__ + "static/media/dot.a300def6.svg";